"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_1 = require("../../../theming/theme");

exports.PrimaryTextBox = function (props) {
  return react_1.default.createElement(react_native_1.Text, {
    style: [styles.basicText, props.textBoxStyle]
  }, props.caption);
};

var basicText = {
  color: theme_1.GreyScale.lightest,
  flexGrow: 0,
  fontFamily: theme_1.FontStyles.DefaultDarkFont.fontFamily,
  fontSize: theme_1.FontSize.regular,
  textAlign: 'center'
};
var styles = react_native_1.StyleSheet.create({
  basicText: basicText
});